define("shared/components/shared/social/linkedin-profile-info-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{@handleClose}}
    as
    |modal|
  >
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "linkedin.profile_info.title"}} />
      <modal.card-body>
        <div class="u--row u--m__b__lg">
          <div class="u--col__2">
            <img
              class="tOB--avatar"
              src="/assets/images/img--linkedinPersonalProfile.svg"
            >
          </div>
          <div class="u--col__10">
            <p class="u--m__0 u--text--md">
              {{html-safe (t "linkedin.profile_info.personal_profile")}}
            </p>
          </div>
        </div>
        <div class="u--row u--m__b__md">
          <div class="u--col__2">
            <img
              class="tOB--avatar"
              src="/assets/images/img--linkedinOrganization.svg"
            >
          </div>
          <div class="u--col__10">
            <p class="u--m__0 u--text--md">
              {{html-safe (t "linkedin.profile_info.pages")}}
            </p>
          </div>
        </div>
        <div class="u--row">
          <div class="u--col__12">
            <p class="u--m__0 u--m__tb">
              {{html-safe (t "linkedin.profile_info.more_info")}}
              <Shared::Link
                @href="https://help.later.com/hc/articles/360063905933"
                @text={{t "linkedin.profile_info.help_article"}}
              />
            </p>
          </div>
        </div>
      </modal.card-body>
      <modal.card-footer>
        <Shared::Ui::Button
          @type="outline"
          @additional="block"
          @text={{t "shared_words.close"}}
          {{on "click" @handleClose}}
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "IwTyvuxB",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"linkedin.profile_info.title\"],null]]],null],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row u--m__b__lg\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__2\"],[12],[1,\"\\n          \"],[10,\"img\"],[14,0,\"tOB--avatar\"],[14,\"src\",\"/assets/images/img--linkedinPersonalProfile.svg\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--col__10\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--m__0 u--text--md\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[[28,[37,1],[\"linkedin.profile_info.personal_profile\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--row u--m__b__md\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__2\"],[12],[1,\"\\n          \"],[10,\"img\"],[14,0,\"tOB--avatar\"],[14,\"src\",\"/assets/images/img--linkedinOrganization.svg\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--col__10\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--m__0 u--text--md\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[[28,[37,1],[\"linkedin.profile_info.pages\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--m__0 u--m__tb\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[[28,[37,1],[\"linkedin.profile_info.more_info\"],null]],null]],[1,\"\\n            \"],[8,[39,3],null,[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/360063905933\",[28,[37,1],[\"linkedin.profile_info.help_article\"],null]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,4],[[4,[38,5],[\"click\",[30,1]],null]],[[\"@type\",\"@additional\",\"@text\"],[\"outline\",\"block\",[28,[37,1],[\"shared_words.close\"],null]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@handleClose\",\"modal\"],false,[\"shared/modal\",\"t\",\"html-safe\",\"shared/link\",\"shared/ui/button\",\"on\"]]",
    "moduleName": "shared/components/shared/social/linkedin-profile-info-modal.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});